export type OrgNameTinType = {
    tin: string;
    name: string;
};

export function formatOrgName(org: OrgNameTinType) {
    const name = `(${org.tin}) ${org.name}`;
    if (name.length >= 65) {
        return `${name.substr(0, 65)}...`;
    }
    return name;
}
